import invariant from 'ts-invariant'

import { FeatureFlags } from '@/env/feature-flags.ts'

export type TAppEnvName = 'local' | 'prod' | 'alphaui' | 'uat' | 'dev'

export interface IAppEnv {
    clientId: string
    tenantId: string
    redirectUri: string
    chatUrl: string
    uploadToAgentUrl: string
    promptUrl: string
    utilityUrl: string
    approvalsUrl: string
    translateURL: string
    healthCheckUrl: string
    healthCheckNodeUrl: string
    appInsightsConnectionString: string
    coreChatUrl: string
    features: FeatureFlags
}

const env: Record<TAppEnvName, IAppEnv> = {
    local: {
        clientId: '0449eddb-1af7-4474-b594-7d44c5919d07',
        tenantId: '63982aff-fb6c-4c22-973b-70e4acfb63e6',
        redirectUri: 'http://localhost:5173',
        chatUrl: 'https://dev.api.gsk.com/gigichat',
        uploadToAgentUrl: 'https://dev.api.gsk.com/gigi',
        promptUrl: 'https://dev.api.gsk.com/gigi/prompt-library',
        utilityUrl: 'https://dev.api.gsk.com/chatgptutility-az',
        approvalsUrl: 'https://dev.api.gsk.com/da-approvals-az',
        translateURL: 'https://dev.api.gsk.com/translations/system',
        healthCheckUrl: 'https://gigi-api-dev.corpnet2.com/dev-chatgpt-api-pyton/ping',
        healthCheckNodeUrl: 'https://gigi-api-dev.corpnet2.com/chatjsdev/ping',
        coreChatUrl: 'https://dev.api.gsk.com/gigicore',
        appInsightsConnectionString:
            'InstrumentationKey=3e733a1b-872d-4d21-84da-3c3e060306db;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/',
        features: new FeatureFlags({
            mobileLock: true,
            proxyChat: true,
            connectToLiveAgent: true,
            webSearch: true,
            messageExport: true,
            promptLibrary: true,
            useAgent: true,
            news: true,
            gigiCore: true,
            imageUnderstanding: true,
            glossaries: true,
            mimeTypesNode: true,
        }),
    },
    alphaui: {
        clientId: '0449eddb-1af7-4474-b594-7d44c5919d07',
        tenantId: '63982aff-fb6c-4c22-973b-70e4acfb63e6',
        redirectUri: 'https://alphaui.gigi.gsk.com',
        chatUrl: 'https://dev.api.gsk.com/gigichat-alphaui',
        uploadToAgentUrl: 'https://dev.api.gsk.com/gigi',
        promptUrl: 'https://dev.api.gsk.com/gigi/prompt-library',
        utilityUrl: 'https://dev.api.gsk.com/chatgptutility-az',
        approvalsUrl: 'https://dev.api.gsk.com/da-approvals-az',
        translateURL: 'https://dev.api.gsk.com/translations/system',
        healthCheckUrl: 'https://gigi-api-dev.corpnet2.com/dev-chatgpt-api-pyton/ping',
        healthCheckNodeUrl: 'https://gigi-api-dev.corpnet2.com/chatjsdev/ping',
        coreChatUrl: 'https://dev.api.gsk.com/gigicore-alphaui',
        appInsightsConnectionString:
            'InstrumentationKey=3e733a1b-872d-4d21-84da-3c3e060306db;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/',
        features: new FeatureFlags({
            mobileLock: true,
            proxyChat: false,
            connectToLiveAgent: false,
            webSearch: false,
            messageExport: false,
            promptLibrary: true,
            useAgent: false,
            news: false,
            gigiCore: false,
            imageUnderstanding: false,
            glossaries: false,
            mimeTypesNode: false,
        }),
    },
    dev: {
        clientId: '0449eddb-1af7-4474-b594-7d44c5919d07',
        tenantId: '63982aff-fb6c-4c22-973b-70e4acfb63e6',
        redirectUri: 'https://dev.gigi.gsk.com',
        chatUrl: 'https://dev.api.gsk.com/gigichat',
        uploadToAgentUrl: 'https://dev.api.gsk.com/gigi',
        promptUrl: 'https://dev.api.gsk.com/gigi/prompt-library',
        utilityUrl: 'https://dev.api.gsk.com/chatgptutility-az',
        approvalsUrl: 'https://dev.api.gsk.com/da-approvals-az',
        translateURL: 'https://dev.api.gsk.com/translations/system',
        healthCheckUrl: 'https://gigi-api-dev.corpnet2.com/dev-chatgpt-api-pyton/ping',
        healthCheckNodeUrl: 'https://gigi-api-dev.corpnet2.com/chatjsdev/ping',
        coreChatUrl: 'https://dev.api.gsk.com/gigicore',
        appInsightsConnectionString:
            'InstrumentationKey=3e733a1b-872d-4d21-84da-3c3e060306db;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/',
        features: new FeatureFlags({
            mobileLock: true,
            proxyChat: true,
            connectToLiveAgent: true,
            webSearch: true,
            messageExport: true,
            promptLibrary: true,
            news: true,
            useAgent: true,
            gigiCore: true,
            imageUnderstanding: true,
            glossaries: true,
            mimeTypesNode: true,
        }),
    },
    uat: {
        clientId: '22fb3192-c1d1-4420-84ec-ff82f346a2d7',
        tenantId: '63982aff-fb6c-4c22-973b-70e4acfb63e6',
        redirectUri: 'https://uat-gigi.gsk.com',
        chatUrl: 'https://qa.api.gsk.com/gigichat',
        uploadToAgentUrl: 'https://qa.api.gsk.com/gigi',
        promptUrl: 'https://qa.api.gsk.com/gigi/prompt-library',
        utilityUrl: 'https://qa.api.gsk.com/chatgptutility-az',
        approvalsUrl: 'https://qa.api.gsk.com/da-approvals-az',
        translateURL: 'https://qa.api.gsk.com/translations/system',
        healthCheckUrl: 'https://orchestra-api-uat.corpnet2.com/uat-chatgpt-api-pyton/ping',
        healthCheckNodeUrl: 'https://orchestra-api-uat.corpnet2.com/chatjsuat/ping',
        coreChatUrl: 'https://qa.api.gsk.com/gigicore',
        appInsightsConnectionString:
            'InstrumentationKey=3e733a1b-872d-4d21-84da-3c3e060306db;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/',
        features: new FeatureFlags({
            mobileLock: true,
            proxyChat: false,
            connectToLiveAgent: false,
            webSearch: true,
            messageExport: true,
            promptLibrary: true,
            useAgent: false,
            news: false,
            gigiCore: false,
            imageUnderstanding: false,
            glossaries: false,
            mimeTypesNode: true,
        }),
    },
    prod: {
        clientId: 'bd489d42-7d5f-4e1c-b07a-2c64efc791df',
        tenantId: '63982aff-fb6c-4c22-973b-70e4acfb63e6',
        redirectUri: 'https://gigi.gsk.com',
        chatUrl: 'https://api.gsk.com/gigichat',
        uploadToAgentUrl: 'https://api.gsk.com/gigi',
        promptUrl: 'https://api.gsk.com/gigi/prompt-library',
        utilityUrl: 'https://api.gsk.com/chatgptutility-az',
        approvalsUrl: 'https://api.gsk.com/da-approvals-az',
        translateURL: 'https://api.gsk.com/translations/system',
        healthCheckUrl: 'https://orchestra-api-prod.corpnet2.com/prod-chatgpt-api-pyton/ping',
        healthCheckNodeUrl: 'https://orchestra-api-prod.corpnet2.com/chatjsprod/ping',
        coreChatUrl: 'https://api.gsk.com/gigicore',
        appInsightsConnectionString:
            'InstrumentationKey=a5a77307-9211-44f7-98b8-85a9aa58f0bd;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=ed4ba600-18e4-431e-86c5-dc35f776c3b3',
        features: new FeatureFlags({
            mobileLock: true,
            proxyChat: false,
            connectToLiveAgent: false,
            webSearch: true,
            messageExport: true,
            promptLibrary: true,
            useAgent: false,
            news: false,
            gigiCore: false,
            imageUnderstanding: false,
            glossaries: false,
            mimeTypesNode: true,
        }),
    },
} as const

export const _appEnv: unknown = import.meta.env.VITE_APP_ENV

function isKnownEnv(appEnv: unknown): appEnv is TAppEnvName {
    return typeof appEnv === 'string' && appEnv in env
}

invariant(isKnownEnv(_appEnv), `VITE_APP_ENV must be one of ${Object.keys(env).join(', ')}`)

export const appEnvName = _appEnv
export const currentEnv = env[appEnvName]
window.gigiFeatures = currentEnv.features
